import React from "react";
import { ExternalLink, IExternalLinkProps } from "../external-link";
import style from "./style.module.css";

export interface IReadMoreProps {
    links: IExternalLinkProps[];
    onNav: (nav: string) => void
}

export function ReadMore(props: IReadMoreProps) {
    return (
        <section className={style.readMore}>
            <span className={style.title}>Read more</span>
            {
                props.links.map((link: IExternalLinkProps) => {
                    return (
                        <ExternalLink
                            key={link.cta}
                            {...link}
                            internal={true}
                            onNav={props.onNav}
                        />
                    );
                })
            }
        </section>

    )
}